import { UI } from '@/Components/UI';
import { useForm } from '@/Contexts';

export const RecipeCollectionForm = () => {
    const form = useForm();

    if (!form) {
        throw new Error('RecipeCollectionForm must be used within a FormProvider');
    }

    return (
        <>
            <UI.Form.Input
                name={'title'}
                label={'Name'}
                required />

            <UI.Form.Checkbox
                name={'isPublic'}
                label={'Public Collection'}
                defaultChecked={true} />

            <UI.Button
                type={'submit'}
                disabled={form.processing}>
                Save Collection
            </UI.Button>
        </>
    );
};
